import React from "react";
import {
  BriefcaseIcon,
  CalendarIcon,
  CashIcon,
  ClipboardIcon,
  ColorSwatchIcon,
  DocumentTextIcon,
  PresentationChartBarIcon,
  SwitchHorizontalIcon,
  IdentificationIcon,
  BookOpenIcon,
  UserGroupIcon,
  HomeIcon,
  CogIcon,
  MapIcon,
  ChatAltIcon,
  GlobeAltIcon,
  TemplateIcon,
  CheckCircleIcon,
} from "@heroicons/react/solid";

export const sidebarOptions = [
    {
      name: "",
      label: "Dashboard",
      icon: <PresentationChartBarIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "employee-details",
      label: "User Details",
      icon: <BriefcaseIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "department",
      label: "Department",
      icon: <UserGroupIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "shifts",
      label: "Shifts",
      icon: <SwitchHorizontalIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "salary",
      label: "Salary",
      icon: <CashIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "salary-templates",
      label: "Salary Templates",
      icon: <TemplateIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "approvals",
      label: "Approvals",
      icon: <CheckCircleIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "employment-management",
      label: "Employment",
      icon: <ColorSwatchIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "user-attendance",
      label: "Attendance",
      icon: <DocumentTextIcon className="w-6" />,
      role: "EMPLOYEE",
    },
    {
      name: "leave-application",
      label: "Leave Application",
      icon: <CalendarIcon className="w-6" />,
      role: "EMPLOYEE",
    },
    {
      name: "shift-details",
      label: "Shifts Details",
      icon: <SwitchHorizontalIcon className="w-5" />,
      role: "EMPLOYEE",
    },
    {
      name: "leaves-applied",
      label: "Leaves Applied",
      icon: <ClipboardIcon className="w-5" />,
      role: "EMPLOYEE",
    },
    {
      name: "public-holidays",
      label: "Public Holidays",
      icon: <CalendarIcon className="w-5" />,
      role: "BOTH",
    },
    {
      name: "attendance",
      label: "Attendance",
      icon: <SwitchHorizontalIcon className="w-6" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "web-check-ins",
      label: "Web Check-ins",
      icon: <IdentificationIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "hand-book",
      label: "Hand Books",
      icon: <BookOpenIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "wfh",
      label: "Remote Work",
      icon: <HomeIcon className="w-5" />,
      role: "EMPLOYEE",
    },
    {
      name: "chats",
      label: "Chats",
      icon: <ChatAltIcon className="w-5" />,
      role: "EMPLOYEE",
      feature: "chat",
    },
    {
      name: "work-from-home-approval",
      label: "Remote Work",
      icon: <HomeIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "live_tracking/users",
      label: "Trips",
      icon: <MapIcon className="w-5" />,
      role: "COMPANY_ADMIN",
      feature: "liveTracking",
    },
    {
      name: "geofencing",
      label: "Geofencing",
      icon: <GlobeAltIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
    {
      name: "company-settings",
      label: "Company Settings",
      icon: <CogIcon className="w-5" />,
      role: "COMPANY_ADMIN",
    },
];
